<div class="time-off-balance-info-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <button mat-icon-button class="close-button" aria-label="Close" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    @for (sentence of data.sentences; track $index) {
      <p class="balance-footnote">
        @for (part of sentence; track $index) {
          @if (part.value !== null) {
            <span class="balance-value" [ngClass]="getBalanceValueClass(part.value)">{{ part.text }}</span>
          } @else if (part.bold) {
            <span class="footnote-bold">{{ part.text }}</span>
          } @else {
            <!-- Wrapped in a span so template whitespace can't add stray spaces
                 around the text (e.g. before periods); spacing comes from the
                 part text itself. -->
            <span>{{ part.text }}</span>
          }
        }
      </p>
    }
  </mat-dialog-content>
</div>
